"use client";

const Fallback = ({ error, resetErrorBoundary }) => {
	return (
		<>
			<h1>Something went wrong</h1>
			<div>{error.message}</div>
			<button onClick={resetErrorBoundary}>Try again</button>
		</>
	);
};

export default Fallback;
